import { CheckCircle, AlertCircle, XCircle } from 'lucide-react'
import styles from './QualityBadge.module.css'

export type QualityStatus = 'ok' | 'warning' | 'error'

export interface QualityBadgeProps {
  status: QualityStatus
  issues?: string[]
}

export function QualityBadge({ status, issues }: QualityBadgeProps) {
  const Icon = status === 'ok' ? CheckCircle : status === 'warning' ? AlertCircle : XCircle
  const label = status === 'ok' ? 'OK' : status === 'warning' ? 'Hinweis' : 'Fehler'

  return (
    <span
      className={[styles.badge, styles[status]].join(' ')}
      title={issues?.join(' · ') || undefined}
    >
      <Icon size={12} />
      {label}
    </span>
  )
}
